<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.userrequests.loadingCompanyUserRequests"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.userrequests.companyUserRequestsCount"
				:loading-info="$store.state.userrequests.loadingCompanyUserRequests"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="reportsList"
				:server-items-length="$store.state.userrequests.companyUserRequestsCount"
				item-key="id"
				class="budget-table"
				:loading="$store.state.userrequests.loadingCompanyUserRequests"
				:options.sync="options"
				loading-text="Cargando datos..."
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.client="{ item }">
					<div class="d-flex align-center">
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ getUserName(item) }}</b>
							<div v-if="item.morphable">{{ item.morphable.client ? item.morphable.client.email:'No identificado'}}</div>
						</div>
						<div class="d-flex align-self-start align-start justify-end">
							<v-tooltip bottom v-if="item.morphable?.client?.company_profile && item.morphable?.client?.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Cliente Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Cliente Persona Natural</span>
							</v-tooltip>
						</div>
					</div>
				</template>
				<template v-slot:item.project="{ item }">
					<div class="d-flex flex-column" v-if="item.project_line_id">
						<p class="mb-0">{{ getItemProjectName(item) }}</p>
						<p class="mb-0 font-weight-bold">{{ getItemProjectAddress(item) }}</p>
					</div>
					<div class="d-flex flex-column" v-else>
						<p class="mb-0 font-weight-bold">Nuevo Proyecto</p>
						<p class="mb-0">{{ item.project_type?.parent?.name }} - {{ item.project_type?.name }}</p>
					</div>
				</template>
				<template v-slot:item.status="{ item }">
					<div>
						<div class="d-flex align-center">
							<div>
								<v-chip
									:color="getStatusColor( item.status )"
									label
									outlined
									x-small
									class="px-1"
								>
									<b>{{ getStatusText( item.status ) }}</b>
								</v-chip>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:item.created="{ item }">
					<div><b>{{ item.created_at | toDateTime }}</b></div>
					<v-chip
						color="green"
						label
						outlined
						x-small
						v-if="item.id == $store.state.userrequests.companyUserRequestsLastId"
					>
						<b>Último Creado</b>
					</v-chip>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="#959595"
								class="mx-1"
								@click="$store.commit('userrequests/setUserRequestModalId', item.id)"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-file-document-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver Solicitud</span>
					</v-tooltip>
					<v-tooltip bottom v-if="associatedCrm(item)">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="#959595"
								class="mx-1"
								@click="openCrm(associatedCrm(item))"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-contacts-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver CRM</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.userrequests.companyUserRequestsCount"
				:loading-info="$store.state.userrequests.loadingCompanyUserRequests"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'UserRequestsIndex',
	components: {
		DataTablePagination,
	},
  data() {
    return {
			selectedRowItem: null,
      search: '',
			prefixMenu: false,
			searchInput: null,
			lastWorkingBudget: null,
			budgetStatuses: [
				{value: 1, title: 'Creado'},
				{value: 2, title: 'Enviado'},
				{value: 3, title: 'Observado'},
				{value: 4, title: 'Aceptado'},
				{value: 5, title: 'Rechazado'},
			],
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
      }
    };
  },
  computed: {
		headers(){
			let headers = [
				// { text: 'Nº', value: 'serial', class: 'with-divider', cellClass: 'with-divider', sortable: false },
				{ text: 'Cliente', value: 'client', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        // { text: 'Seguimiento', value: 'details', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Proyecto', value: 'project', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Fecha Creación', value: 'created', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Estado', value: 'status', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false },
			]
			return headers.filter((header) => {
				return this.$store.state.userrequests.listingColumns[header.value]
			})
		},
		reportsList(){
			return this.$store.state.userrequests.companyUserRequests
		},
    filteredUsers() {
      return this.$store.state.users.usersList.filter(user => {
        return (
          user.name.toLowerCase().includes(this.search.toLowerCase()) ||
          user.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		queryRoute(){
			return this.$route.query
		}
  },
	watch: {
    options: {
      handler() {
				this.reloadInfo()
      },
      deep: true,
    },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		},
		queryRoute(){
			const user_request_id = this.$route.query.id
			if(user_request_id){
				this.selectedRowItem = user_request_id
				this.$store.commit('userrequests/setUserRequestModalId', user_request_id)
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
			this.$store.dispatch('users/getUserFromCompany')
		}
		if(this.queryRoute.id){
			this.selectedRowItem = this.queryRoute.id
			this.$store.commit('userrequests/setUserRequestModalId', this.queryRoute.id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_requestslist_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
    eventBus.$on('reloadInformation', this.reloadInfo)
	},
	beforeDestroy() {
		eventBus.$off('reloadInformation', this.reloadInfo)
	},
  methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_requestslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		associatedCrm(user_request) {
			if(user_request.status == 2 && user_request.project_line_associations){
				return user_request.project_line_associations.find((item) => {
					return item.morphable_type == 'App\\Models\\BotConversation'
				})
			}
			return null
		},
		openCrm(crm){
			this.$store.commit('crm/setCrmModalId', crm.morphable_id)
		},
		getStatusColor(status){
			if(status === 1){
				return '#524D4D'
			}
			else if(status === 2){
				return 'green'
			}
			else if(status === 3){
				return 'red'
			}
		},
		getStatusText(status){
			if(status === 1){
				return 'Creado'
			}
			else if(status === 2){
				return 'Aceptado'
			}
			else if(status === 3){
				return 'Rechazado'
			}
		},
		getProjectType(items){
			const hierarchy = {
				'App\\Models\\BotConversation': 1,
				'App\\Models\\PreProject': 2,
				'App\\Models\\Project': 3
			};
			const mostRelevant = items.reduce((highest, current) => {
				const currentLevel = hierarchy[current.morphable_type] || 0;
				const highestLevel = highest ? hierarchy[highest.morphable_type] || 0 : 0;

				return currentLevel > highestLevel ? current : highest;
			}, null);
			return mostRelevant;

		},
		getItemProjectName(item){
			const project = this.getProjectType(item.project_line_associations)
			return project?.morphable?.name || item.project_name || '--'
		},
		getItemProjectAddress(item){
			const project = this.getProjectType(item.project_line_associations)
			return project?.morphable?.info?.address?.address || item.address?.address || '--'
		},
		getUserName(request){
			let name = ''
			const item = request.user
			if(item.profile){
				name = item.profile.name + ' ' + item.profile.lastname + ' ' + item.profile.second_lastname
			}
			return name
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.reloadInfo()
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('userrequests/getCompanyUserRequests', data)
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    }
  },
};
</script>

<style scoped>
</style>
<style>
.budget-index .message-container{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.budget-index .message-container p{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.budget-table table tr td{
	font-size: 11px!important;
}
.budget-table.resizable .v-data-table__wrapper th,
.budget-table.resizable .v-data-table__wrapper td {
	border-right: 1px solid #cacaca;
}
.with-divider {
  border-right: 1px solid grey;
}
</style>